var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8SemaineDeLaChronologie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 12.5 6 C 8.9280619 6 6 8.9280619 6 12.5 L 6 35.5 C 6 39.071938 8.9280619 42 12.5 42 L 35.5 42 C 39.071938 42 42 39.071938 42 35.5 L 42 12.5 C 42 8.9280619 39.071938 6 35.5 6 L 12.5 6 z M 12.5 9 L 35.5 9 C 37.450062 9 39 10.549938 39 12.5 L 39 35.5 C 39 37.450062 37.450062 39 35.5 39 L 12.5 39 C 10.549938 39 9 37.450062 9 35.5 L 9 12.5 C 9 10.549938 10.549938 9 12.5 9 z M 15.476562 13.978516 A 1.50015 1.50015 0 0 0 14 15.5 L 14 17.5 A 1.50015 1.50015 0 1 0 17 17.5 L 17 15.5 A 1.50015 1.50015 0 0 0 15.476562 13.978516 z M 15.476562 21.478516 A 1.50015 1.50015 0 0 0 14 23 L 14 25 A 1.50015 1.50015 0 1 0 17 25 L 17 23 A 1.50015 1.50015 0 0 0 15.476562 21.478516 z M 15.476562 28.978516 A 1.50015 1.50015 0 0 0 14 30.5 L 14 32.5 A 1.50015 1.50015 0 1 0 17 32.5 L 17 30.5 A 1.50015 1.50015 0 0 0 15.476562 28.978516 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8SemaineDeLaChronologie);
export default __webpack_public_path__ + "static/media/icons8-semaine-de-la-chronologie.88d3e430365ab1c1539b571880d13693.svg";
export { ForwardRef as ReactComponent };